class StickyAddToCartComponent extends HTMLElement {
  constructor() {
    super();
    this.isStuck = false;
    this.observer = null;
  }

  connectedCallback() {
    setTimeout(() => this.init(), 800);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  init() {
    // Dawn theme specific selectors
    const addToCartBtn = document.querySelector('.product-form__submit');

    if (!addToCartBtn) {
      console.log('Sticky ATC: Button not found, retrying...');
      setTimeout(() => this.init(), 1000);
      return;
    }

    console.log('Sticky ATC: Found button, observing...');

    // Simple intersection observer - watches the main ATC button
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Main button is visible - hide sticky bar
          this.hide();
        } else {
          // Main button is NOT visible - show sticky bar
          // But only if user has scrolled PAST it (not before it)
          const rect = entry.boundingClientRect;
          if (rect.top < 0) {
            this.show();
          } else {
            this.hide();
          }
        }
      });
    }, {
      threshold: 0,
      rootMargin: '0px'
    });

    this.observer.observe(addToCartBtn);

    // Handle sticky button click
    const stickyBtn = this.querySelector('[ref="addToCartButton"]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        addToCartBtn.click();
      });
    }
  }

  show() {
    const bar = this.querySelector('[ref="stickyBar"]');
    if (!bar || this.isStuck) return;
    this.isStuck = true;
    bar.dataset.stuck = 'true';
    console.log('Sticky ATC: Showing');
  }

  hide() {
    const bar = this.querySelector('[ref="stickyBar"]');
    if (!bar || !this.isStuck) return;
    this.isStuck = false;
    bar.dataset.stuck = 'false';
    console.log('Sticky ATC: Hiding');
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCartComponent);
}